import "./globalStyles.css";
import { Themes } from "@/typings/theme";

import defaultTheme from "./defaultTheme";

const themes: Themes = {
  defaultTheme: defaultTheme,
};

export default themes;
